import React from "react";

type Props = {
  color?: string;
  thickness?: number;
  margin?: string;
  className?: string;
};

export default function HorizontalRule({
  className,
  thickness = 1,
  margin = "1rem 0",
}: Props) {
  const style = {
    height: `${thickness}px`,
    marginTop: margin,
    marginBottom: margin,
  };

  return <hr className={className} style={style} />;
}
